module.exports = __webpack_public_path__ + "static/media/1.95e32b8d.jpg";